// The shared logout entry asks the live phone before revoking its session.
let confirmExit: (() => boolean) | null = null
export function registerPhoneExitGuard(guard: () => boolean) {
  confirmExit = guard
  return () => { if (confirmExit === guard) confirmExit = null }
}
export function canExitNextPhone() { return confirmExit ? confirmExit() : true }
export const NEXT_SESSION_CLEARED = 'jarvis-next-session-cleared'
